import { render, staticRenderFns } from "./Word2.vue?vue&type=template&id=5623db86&scoped=true&"
import script from "./Word2.vue?vue&type=script&lang=js&"
export * from "./Word2.vue?vue&type=script&lang=js&"
import style0 from "./Word2.vue?vue&type=style&index=0&id=5623db86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5623db86",
  null
  
)

export default component.exports